import { createConfig, http } from 'wagmi';
import { injected, walletConnect } from 'wagmi/connectors';
import { robinhoodTestnet, robinhoodMainnet, ROBINHOOD_MAINNET_ENABLED } from './chains';

// WalletConnect requires a Project ID from https://cloud.walletconnect.com.
// Set via REACT_APP_WALLETCONNECT_PROJECT_ID in the deployment environment.
const walletConnectProjectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID;

const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://lilverse.redexct.com';

const walletConnectMetadata = {
    name: 'Lilverse',
    description: 'Lilverse — Animations, comics, memes and more.',
    url: siteUrl,
    icons: [`${siteUrl}/logo.png`],
};

const chains = ROBINHOOD_MAINNET_ENABLED
    ? [robinhoodTestnet, robinhoodMainnet]
    : [robinhoodTestnet];

const connectors = [injected()];
if (walletConnectProjectId) {
    connectors.push(
        walletConnect({
            projectId: walletConnectProjectId,
            showQrModal: true,
            metadata: walletConnectMetadata,
        })
    );
}

export const wagmiConfig = createConfig({
    chains,
    connectors,
    transports: Object.fromEntries(chains.map((chain) => [chain.id, http()])),
    // No auto-connect: the doctrine requires explicit user intent for every
    // wallet interaction, not a silent reconnect on page load.
});

export const isWalletConnectConfigured = Boolean(walletConnectProjectId);
